import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const ConnectExistingStripe = async (returnUrl, navigate) => {
  const accesstoken = getToken();
  

  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        returnUrl 
      }).toString();
      const response = await fetch(`${dev_baseUrl}/StripeConnect/connect-existing?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else {
        return data;
      }     
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const CreateAndConnectStripe = async (returnUrl, navigate) => {
    const accesstoken = getToken();
    
    if (accesstoken) {
      try {
        const queryParams = new URLSearchParams({
          returnUrl 
        }).toString();
        const response = await fetch(`${dev_baseUrl}/StripeConnect/onboarding?${queryParams}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const data = await response.json();        
  
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
            navigate(`/login`);
        } else {
          return data;
        }     
      } catch (error) {
        console.error('Network error:', error);
        return [];
      }
    } else {
      console.warn('Access token is not available.');
      return { form: 'Access token is missing.' };
    }
  };

export const OAuthCallback = async (code,state,error,error_description, navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const queryParams = new URLSearchParams({
            code,
            state             
        }).toString();
        const response = await fetch(`${dev_baseUrl}/StripeConnect/oauth-callback?${queryParams}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const data = await response.json();        
  
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
            navigate(`/login`);
        } else {
          return data;
        }     
      } catch (error) {
        console.error('Network error:', error);
        return [];
      }
    } else {
      console.warn('Access token is not available.');
      return { form: 'Access token is missing.' };
    }
  };
  
export const GetStripeStatus = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(`${dev_baseUrl}/StripeConnect/getAccountStatus`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const data = await response.json();        
  
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
            navigate(`/login`);
        } else {
          return data;
        }     
      } catch (error) {
        console.error('Network error:', error);
        return [];
      }
    } else {
      console.warn('Access token is not available.');
      return { form: 'Access token is missing.' };
    }
  };

export const GetStripeAccount = async (navigate) => {
    const accesstoken = getToken();
    if (accesstoken) {
      try {
        const response = await fetch(`${dev_baseUrl}/StripeConnect/GetStripeAccount`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const data = await response.json();        
  
        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
            navigate(`/login`);
        } else {
          return data;
        }     
      } catch (error) {
        console.error('Network error:', error);
        return [];
      }
    } else {
      console.warn('Access token is not available.');
      return { form: 'Access token is missing.' };
    }
  };

export const DeleteStripeAccount = async (navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/StripeConnect/DeleteStripeAccount`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else {
        return data;
      }     
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const CreateCheckoutSession = async (paymentId) => {  
    try {
      const response = await fetch(`${dev_baseUrl}/CustomerPayment/create-checkout-session?paymentId=${paymentId}`, {
        method: 'GET',
        headers: {          
          'Content-Type': 'application/json',
        },
      });      
      const data = await response.json();        
      return data;

    } catch (error) {
      console.error('Network error:', error);
      return [];
    } 
};

export const VerifyAndUpdatePaymentStatus = async (sessionId) => {  
  try {
    const response = await fetch(`${dev_baseUrl}/CustomerPayment/VerifyAndUpdatePaymentStatus?session_id=${sessionId}`, {
      method: 'GET',
      headers: {          
        'Content-Type': 'application/json',
      },
    });      
    const data = await response.json();        
    return data;

  } catch (error) {
    console.error('Network error:', error);
    return [];
  } 
};